import { ApolloLink } from "./ApolloLink.js";
export var empty = ApolloLink.empty;
//# sourceMappingURL=empty.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@apollo/client/link/core/empty.js
// module id = 1493
// module chunks = 4